//Bibliotecas
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
//Componentes material
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CssBaseline from '@material-ui/core/CssBaseline';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
//Componentes
import Layout from './Layout';
import ImageInput from '../components/ImageInput';
import VitalizePaper from '../components/VitalizePaper';
import LabelSecao from '../components/LabelSecao';
import MaskedInput from 'react-text-mask';
import VitalizeFab from '../components/VitalizeFab';
//Controllers
import EmpresaController from '../controllers/EmpresaController';
import TipoEmpresaController from '../controllers/TipoEmpresaController';
//Úteis
import formatarUrlImagem from '../utils/formatarUrlImagem';
import { MascaraDocumento } from '../utils/mascara';

/**
 * Página com um formulário para edição e inclusão de empresas
 */
class EmpresaFormPage extends React.Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLogoChange = this.handleLogoChange.bind(this);
        this.handleLogoError = this.handleLogoError.bind(this);
        this.handleTipoDocumentoChange = this.handleTipoDocumentoChange.bind(this);
        //Controller
        this.empresaController = new EmpresaController();
        this.tipoEmpresaController = new TipoEmpresaController();
        //Estado inicial
        this.state = {
            valores: {
                nome: '',
                cpfCnpj: '',
                tipoEmpresa: '',
                dataLimite: new Date().toISOString().substring(0, 10),
                logo: '',
                'usuario.nome': '',
                'usuario.email': '',
                'usuario.telefone': '',
                'usuario.senha': '',
            },
            erros: {
                nome: '',
                cpfCnpj: '',
                tipoEmpresa: '',
                dataLimite: '',
                logo: '',
                'usuario.nome': '',
                'usuario.email': '',
                'usuario.telefone': '',
                'usuario.senha': '',
            },
            tiposEmpresa: [],
            sucesso: false,
            processando: false,
            carregando: true,
            logoPlaceholder: '',
            tipoDocumento: 'CPF',
            mascaraDocumento: MascaraDocumento['CPF']
        };
    }

    /**
     * Carrega os dados da empresa sendo editada e os tipos de empresas
     */
    async componentDidMount() {
        const id = this.getId();
        const state = Object.assign({}, this.state);
        state.carregando = false; //Indica que a consulta terminou
        if (id > 0)
        {
            const empresa = await this.empresaController.obter(id);
            if (empresa.sucesso) {
                state.valores = {
                    nome: empresa.nome,
                    cpfCnpj: empresa.cpfCnpj,
                    tipoEmpresa: empresa.tipoEmpresa,
                    dataLimite: empresa.dataLimite,
                    logo: '',
                    'usuario.nome': empresa.usuario.nome,
                    'usuario.email': empresa.usuario.email,
                    'usuario.telefone': empresa.usuario.telefone,
                    'usuario.senha': ''
                };

                //Identificando tipo de documento e máscara
                state.tipoDocumento = empresa.cpfCnpj.length > 11 ? 'CNPJ' : 'CPF';
                state.mascaraDocumento = MascaraDocumento[state.tipoDocumento];

                if (empresa.logo)
                    state.logoPlaceholder = formatarUrlImagem(empresa.logo);
            }
        }

        state.tiposEmpresa = await this.obterTiposEmpresa();
        this.setState(state);
    }

    /**
     * Carrega os tipos de empresa da API
     */
    async obterTiposEmpresa() {
        const result = await this.tipoEmpresaController.listar();
        if (result.sucesso) 
            return result.items;
        else
            return [];
    }

    /**
     * Recupera o Id da empresa a ser editada dos parâmetros da URL
     */
    getId() {
        let id;
        if (this.props.match)
            id = this.props.match.params.id;
        if (id === 'add')
            return 0;
        else
            return parseInt(id);
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        //Atualiza somente o valor do campo alterado
        state.valores[event.target.name] = event.target.value;
        //Atualiza o estado
        this.setState(state);
    }

    /**
     * Trata as alteração no tipo de documento
     * @param {*} event Objeto contendo os dados do evento
     */
    handleTipoDocumentoChange(event) {
        //Captura o tipo de documento selecionado
        const tipoDocumento = event.target.value;
        //Identifica a máscara
        const mascaraDocumento = MascaraDocumento[tipoDocumento];
        //Altera o status da página
        this.setState({ tipoDocumento, mascaraDocumento });
    }

    /**
     * Trata as alterações no logo
     * @param {*} component Componente que originou o evento
     * @param {String} value Imagem selecionada em base64
     */
    handleLogoChange(component, value) {
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        //Atualiza somente o valor do campo alterado
        state.valores.logo = value;
        //Limpando mensagem de erro
        state.erros.logo = '';
        //Atualiza o estado
        this.setState(state);
    }

    /**
     * Trata os erros gerados no componente para exibição
     * @param {*} componente Componente que originou o evento
     * @param {String} error Mensagem de erro do componente
     */
    handleLogoError(componente, error) {
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        //Atualiza somente o erro do campo
        state.erros.logo = error;
        //Atualiza o estado
        this.setState(state);
    }

    /**
     * Executa quando o form é submetido.
     * Envia os dados para a API
     * @param {*} event Objeto contendo os dados do evento
     */
    async handleSubmit(event) {
        let result;
        //Impede a propagação do evento
        event.preventDefault();
        //Exibe loader
        this.setState({ processando: true });
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        state.processando = false; //Indica que o processamento terminou
        //Salva o registro
        const id = this.getId();
        //Preenche os dados da requisição
        let dados = {
            nome: state.valores.nome,
            cpfCnpj: state.valores.cpfCnpj,
            tipoEmpresa: state.valores.tipoEmpresa,
            dataLimite: state.valores.dataLimite,
            logo: state.valores.logo,
            usuario: {
                nome: state.valores['usuario.nome'],
                email: state.valores['usuario.email'],
                telefone: state.valores['usuario.telefone'],
                senha: state.valores['usuario.senha'],
            }
        };
        
        if (id === 0)
            result = await this.empresaController.salvar(dados);
        else
            result = await this.empresaController.atualizar({ id, ...dados});

        state.sucesso = result.sucesso;
        if (!result.sucesso) {
            state.erros = this.extrairMensagemErro(result);
        }
        this.setState(state);
    }

    /**
     * Retorna as mensagens de erro da API para exibição no formulário
     * @param {*} resultado Retorno do método salvar da API
     */
    extrairMensagemErro(resultado) {
        const erros = {
            nome: '',
            cpfCnpj: '',
            tipoEmpresa: '',
            logo: '',
            'usuario.nome': '',
            'usuario.email': '',
            'usuario.telefone': '',
            'usuario.senha': ''
        };

        for (let erro of resultado.erros) {
            erros[erro.campo] = erro.mensagem;
        }

        return erros;
    }

    /**
     * Mapeia a lista de tipos de empresa para itens de seleção
     * @param {Array} tiposEmpresa Tipos de empresa retornados pela API
     */
    renderTiposEmpresa(tiposEmpresa) {
        return tiposEmpresa.map(tipoEmpresa => (
            <option key={tipoEmpresa.id} value={tipoEmpresa.id}>{tipoEmpresa.descricao}</option>
        ));
    }

    render() {
        const { onLogout, usuario, empresa, permissoes } = this.props;
        const { sucesso, tiposEmpresa, logoPlaceholder, tipoDocumento, mascaraDocumento, processando, carregando } = this.state;
        const { 
            nome, 
            cpfCnpj, 
            tipoEmpresa, 
            dataLimite, 
            logo,
            'usuario.nome': usuarioNome, 
            'usuario.email': usuarioEmail, 
            'usuario.telefone': usuarioTelefone, 
            'usuario.senha': usuarioSenha 
        } = this.state.valores;
        
        const { 
            nome: nomeErro, 
            cpfCnpj: cpfCnpjErro, 
            tipoEmpresa: tipoEmpresaErro, 
            dataLimite: dataLimiteErro, 
            logo: logoErro,
            'usuario.nome': usuarioNomeErro, 
            'usuario.email': usuarioEmailErro, 
            'usuario.telefone': usuarioTelefoneErro, 
            'usuario.senha': usuarioSenhaErro
        } = this.state.erros;

        let usuarioSenhaHelper = usuarioSenhaErro;
        if (this.getId() > 0 && usuarioSenhaHelper === '')
            usuarioSenhaHelper = 'Deixe vazio para manter a senha';

        if (sucesso) return (<Redirect to="/empresa" />);

        return (
            <Layout onLogout={onLogout} returnLink="/empresa" usuario={usuario} empresa={empresa} permissoes={permissoes} carregando={carregando}>
                <CssBaseline />
                <form onSubmit={this.handleSubmit} noValidate >
                    <VitalizePaper>
                        <Grid container spacing={1}>
                            <Grid item xs={12} >
                                <LabelSecao label="Empresa" />
                            </Grid>
                            <Grid item xs={12} md={6} >
                                <TextField 
                                    name="nome" 
                                    label="Nome" 
                                    type="text" 
                                    placeholder="Nome da empresa" 
                                    required
                                    variant="outlined" 
                                    fullWidth 
                                    error={!!nomeErro}
                                    helperText={nomeErro}
                                    value={nome} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={4} md={2} >
                                <FormControl fullWidth variant="outlined" >
                                    <InputLabel htmlFor="tipo-documento">Tipo documento</InputLabel>
                                    <Select 
                                        id="tipo-documento"
                                        name="tipoDocumento" 
                                        label="Tipo documento"
                                        native 
                                        required
                                        variant="outlined" 
                                        fullWidth 
                                        value={tipoDocumento} 
                                        onChange={this.handleTipoDocumentoChange} 
                                    >
                                        <option value="CPF">CPF</option>
                                        <option value="CNPJ">CNPJ</option>
                                    </Select>
                                    <FormHelperText id="tipo-empresa-helper">{tipoEmpresaErro}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8} md={4} >
                                <TextField 
                                    name="cpfCnpj" 
                                    label="CPF/CNPJ" 
                                    type="text" 
                                    placeholder="CPF ou CNPJ da empresa" 
                                    required
                                    variant="outlined" 
                                    fullWidth 
                                    InputProps={{ inputComponent: MaskedInput, inputProps: { mask: mascaraDocumento } }}
                                    error={!!cpfCnpjErro}
                                    helperText={cpfCnpjErro}
                                    value={cpfCnpj} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={2} >
                                <FormControl fullWidth variant="outlined" error={!!tipoEmpresaErro} >
                                    <InputLabel htmlFor="tipo-empresa">Tipo da empresa</InputLabel>
                                    <Select 
                                        id="tipo-empresa"
                                        name="tipoEmpresa" 
                                        label="Tipo da empresa"
                                        native 
                                        required
                                        variant="outlined" 
                                        fullWidth 
                                        value={tipoEmpresa} 
                                        onChange={this.handleChange} 
                                    >
                                        <option></option>
                                        {this.renderTiposEmpresa(tiposEmpresa)}
                                    </Select>
                                    <FormHelperText id="tipo-empresa-helper">{tipoEmpresaErro}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={8} md={4} >
                                <TextField 
                                    name="dataLimite" 
                                    label="Data limite" 
                                    type="date" 
                                    placeholder="Data limite para utilização" 
                                    required
                                    variant="outlined" 
                                    fullWidth 
                                    error={!!dataLimiteErro}
                                    helperText={dataLimiteErro}
                                    value={dataLimite} 
                                    InputLabelProps={{ shrink: true }}
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <ImageInput 
                                    name="logo"
                                    label="Logo"
                                    placeholder={logoPlaceholder}
                                    value={logo}
                                    errorMessage={logoErro}
                                    onChange={this.handleLogoChange}
                                    onError={this.handleLogoError}
                                />
                            </Grid>
                        </Grid>
                    </VitalizePaper>
                    <VitalizePaper>
                        <Grid container spacing={1}>
                            <Grid item xs={12} >
                                <LabelSecao label="Usuário principal" />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField 
                                    name="usuario.nome" 
                                    label="Nome" 
                                    type="text" 
                                    placeholder="Nome do usuário principal" 
                                    required
                                    variant="outlined" 
                                    fullWidth 
                                    error={!!usuarioNomeErro}
                                    helperText={usuarioNomeErro}
                                    value={usuarioNome} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField 
                                    name="usuario.email" 
                                    label="E-mail" 
                                    type="email" 
                                    placeholder="E-mail do usuário principal" 
                                    required={false}
                                    variant="outlined" 
                                    fullWidth 
                                    error={!!usuarioEmailErro}
                                    helperText={usuarioEmailErro}
                                    value={usuarioEmail} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField 
                                    name="usuario.telefone" 
                                    label="Telefone" 
                                    type="phone" 
                                    placeholder="Telefone do usuário principal" 
                                    required={false}
                                    variant="outlined" 
                                    fullWidth 
                                    InputProps={{ inputComponent: MaskedInput, inputProps: { mask:[ '(', /\d/, /\d/, ')', ' ', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ] } }}
                                    error={!!usuarioTelefoneErro}
                                    helperText={usuarioTelefoneErro}
                                    value={usuarioTelefone} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField 
                                    name="usuario.senha" 
                                    label="Senha" 
                                    type="password" 
                                    placeholder="Senha do usuário"
                                    required={this.getId() === 0}
                                    variant="outlined" 
                                    fullWidth 
                                    error={!!usuarioSenhaErro}
                                    helperText={usuarioSenhaHelper}
                                    value={usuarioSenha} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                        </Grid>
                    </VitalizePaper>
                    <VitalizeFab color="primary" variant="extended" type="submit" loading={processando} >
                            Salvar
                    </VitalizeFab>
                </form>
            </Layout>
        );
    }
}

EmpresaFormPage.propTypes = {
    /** Evento disparado quando o usuário realiza o logout */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired,
    /** Parâmetros da URL */
    match: PropTypes.shape({
        params: PropTypes.shape({
            /** Id da empresa a ser editada */
            id: PropTypes.string
        })
    })
};

export default EmpresaFormPage;